import { Route } from 'react-router-dom';

import KycLayout from '../layout/KycLayout/kycLayout';
import KycAgreement from '../views/Kyc/KycAgreement/KycAgreement';
import KycPersonalDetails from '../views/Kyc/KycPersonalDetails/KycPersonalDetails';
import KycDocuments from '../views/Kyc/KycDocuments/KycDocuments';
import KycDocumentPhotos from '../views/Kyc/KycDocumentPhotos/KycDocumentPhotos';
import KycFinish from '../views/Kyc/KycFinish';
import KycSelfieTime from '../views/Kyc/KycSelfieTIme/KycSelfieTime';
import KycStart from '../views/Kyc/KycStart';
import {
  KYC_AGREEMENT,
  KYC_BIRTH_DETAILS,
  KYC_CONGRATULATIONS,
  KYC_DOCUMENT_DETAILS,
  KYC_DOCUMENT_PHOTOS,
  KYC_SELFIE_TIME,
  KYC_START
} from './routes';

export const KycRoutes = () => {
  return (
    <KycLayout>
      <Route
        exact
        path={KYC_START}
        render={(props) => <KycStart {...props} />}
      />
      <Route
        exact
        path={KYC_AGREEMENT}
        render={(props) => <KycAgreement {...props} />}
      />
      <Route
        exact
        path={KYC_BIRTH_DETAILS}
        render={(props) => <KycPersonalDetails {...props} />}
      />
      <Route
        exact
        path={KYC_DOCUMENT_DETAILS}
        render={(props) => <KycDocuments {...props} />}
      />
      <Route
        exact
        path={`${KYC_DOCUMENT_PHOTOS}/:id`}
        render={(props) => <KycDocumentPhotos {...props} />}
      />
      <Route
        exact
        path={KYC_SELFIE_TIME}
        render={(props) => <KycSelfieTime {...props} />}
      />
      <Route
        exact
        path={KYC_CONGRATULATIONS}
        render={(props) => <KycFinish {...props} />}
      />
    </KycLayout>
  );
};
